module.exports = __webpack_public_path__ + "img/zu_get.64f0ac9.png";